import { useSearchParams } from "react-router-dom";

export default function BondThanks() {
  const [params] = useSearchParams();
  const cancelled = params.get("cancelled");
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B192C] p-6" data-testid="bond-thanks-page">
      <div className="max-w-md rounded-2xl bg-white p-8 text-center">
        <h1 className="font-display text-2xl font-extrabold text-slate-900">{cancelled ? "Payment not completed" : "Thank you - payment received"}</h1>
        <p className="mt-3 text-sm text-slate-600">{cancelled ? "No charge was made. You can use the link in your email again any time before it expires." : "Your surety bond payment went through. Your agent will follow up with your bond documents."}</p>
        <p className="mt-6 text-xs text-slate-400">Elite Real Estate & Finance LLC</p>
      </div>
    </div>
  );
}
